<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      layout="vertical"
      back-button-text="Previous"
      class="wizard-vertical mb-3"
    >

      <!-- account datails tab -->
      <tab-content title="İletişim Bilgilerimiz">
        <b-row>
          <b-col
            cols="12"
            class="mb-2"
          >
            <h1 class="mb-0">
              <center>Winergy Technologies</center><hr>
            </h1>
            <h2 class="text-muted">
              <center>Adres: Ostim OSB Mahallesi 1392.Cad. No:1/15 Yenimahalle/Ankara</center><br>
            </h2>
            <h2 class="text-muted"><center>
              <feather-icon
                icon="PhoneIcon"
                size="25"
              />
              Telefon:<br><hr>
              <a href="#">0312 395 68 28</a></center>
            </h2>
          </b-col>
          <h2
            class="text-muted"
            style="aling:center"
          ><center>
            <feather-icon
              icon="MailIcon"
              size="30"
            />
            E-Posta:<br><hr>
            <a href="#">0312 395 68 28</a></center>
          </h2>
          <b-col
            md="6"
          />
        </b-row>
      </tab-content>

      <!-- personal info tab -->
      <!-- address -->

      <!-- social link -->
    </form-wizard>

  </div>

</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow,
  BCol,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    FormWizard,
    TabContent,
    BRow,
    BCol,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      selectedContry: 'select_value',
      selectedLanguage: 'nothing_selected',
      countryName: [
        { value: 'select_value', text: 'Select Value' },
        { value: 'Russia', text: 'Russia' },
        { value: 'Canada', text: 'Canada' },
        { value: 'China', text: 'China' },
        { value: 'United States', text: 'United States' },
        { value: 'Brazil', text: 'Brazil' },
        { value: 'Australia', text: 'Australia' },
        { value: 'India', text: 'India' },
      ],
      languageName: [
        { value: 'nothing_selected', text: 'Nothing Selected' },
        { value: 'English', text: 'English' },
        { value: 'Chinese', text: 'Mandarin Chinese' },
        { value: 'Hindi', text: 'Hindi' },
        { value: 'Spanish', text: 'Spanish' },
        { value: 'Arabic', text: 'Arabic' },
        { value: 'Malay', text: 'Malay' },
        { value: 'Russian', text: 'Russian' },
      ],
    }
  },
  methods: {
    formSubmitted() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Form Submitted',
          icon: 'EditIcon',
          variant: 'success',
        },
      })
    },
  },
}
</script>
